import React from 'react'
import {
  ButtonIconContainer,
  InputContainer,
  LabelContainer,
  TextFieldContainer,
  TextFieldSubContainer,
  Wrapper
} from './styles'
import searchIcon from '../../assets/icons/search-light.svg'

const SearchField = ({
  error,
  label,
  validated,
  onChange,
  searchButtonColor,
  value = '',
  placeholder = '',
  variant = 'primary'
}) => {
  const [focused, setFocused] = React.useState(false)
  const InputRef = React.useRef(null)

  const handleSearchChange = e => {
    if (onChange) {
      onChange(e.currentTarget.value)
    }
  }

  React.useEffect(() => {
    const listener = event => {
      const el = InputRef?.current

      // Do nothing if clicking ref's element or descendent elements

      if (typeof el === 'object' && el !== null && 'contains' in el) {
        if (el.contains(event.target)) {
          return
        }
      }
      setFocused(false)
    }

    document.addEventListener('click', listener)
    return () => {
      document.removeEventListener('click', listener)
    }
  }, [InputRef, focused])

  return (
    <Wrapper ref={InputRef}>
      <TextFieldContainer>
        {variant === 'secondary' && <LabelContainer>{label}</LabelContainer>}
        <div style={{ display: 'flex', width: '100%' }}>
          <TextFieldSubContainer
            focused={focused}
            touched={value.length > 0}
            error={error}
            validated={validated}
            onClick={() => setFocused && setFocused(true)}
            variant={variant}
            style={{ display: 'flex' }}
          >
            <InputContainer
              variant={variant}
              validated={validated}
              error={error}
            >
              <input
                placeholder={placeholder}
                onChange={handleSearchChange}
                id={label}
                name={label}
                value={value}
              />
            </InputContainer>
          </TextFieldSubContainer>
          <ButtonIconContainer
            searchButtonColor={searchButtonColor}
            variant={variant}
          >
            <img src={searchIcon} alt="icon" />
          </ButtonIconContainer>
        </div>
      </TextFieldContainer>
    </Wrapper>
  )
}

export default SearchField



// WEBPACK FOOTER //
// ./src/components/SearchField/index.js